<div class="row">
  <div class="py-5 style_bg_img row align-items-center">
    <div class="col-sm-8 col-lg-5 mx-auto my-5 text-center text-muted">
      <div class="mb-y">
        <h1 class="display-1"><i class="{{ icon }}"></i></h1>
        <h3 class="mb-3">{{ message }}</h3>
      </div>
    </div>
  </div>
</div>
